import { render } from "./selected-documents.vue?vue&type=template&id=36d20b0d&scoped=true&ts=true&lang=pug"
import script from "./selected-documents.vue?vue&type=script&lang=ts"
export * from "./selected-documents.vue?vue&type=script&lang=ts"

import "./selected-documents.vue?vue&type=style&index=0&id=36d20b0d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d20b0d"]])

export default __exports__